import BlogsList from './List'
import BlogShow from './Show'
import BlogEdit from './Edit'
import BlogCreate from './Create'

const BlogResource = {
  list: BlogsList,
  show: BlogShow,
  edit: BlogEdit,
  create: BlogCreate,
}

export default BlogResource
